export const contractsAddresses: { [key: string]: `0x${string}` } = {
  main: '0x769583aeaBa1494B3186200Fc8957F52A7Ce2673',
  mmpro: '0x6067490d05F3cF2fdFFC0e353b1f5Fd6E5CCDF70',
  usdt: '0x55d398326f99059ff775485246999027b3197955',
  usdc: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
  dai: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
}
